var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.176 2.134a.5.5 0 0 1 .482-.634H8.69a.5.5 0 0 1 .447.276L12.5 8.5h5a1.5 1.5 0 1 1 0 3h-5l-3.362 6.724a.5.5 0 0 1-.447.276H6.658a.5.5 0 0 1-.482-.634L7.944 11.5h-3.11l-.72 2.158A.5.5 0 0 1 3.64 14H1.694a.5.5 0 0 1-.475-.658L2.333 10 1.22 6.658A.5.5 0 0 1 1.694 6H3.64a.5.5 0 0 1 .474.342l.72 2.158h3.11L6.176 2.134Z"
  })));
};
export default SvgPlane;